import { render, staticRenderFns } from "./manuscriptContent.vue?vue&type=template&id=ac8b4e82&"
import script from "./manuscriptContent.vue?vue&type=script&lang=js&"
export * from "./manuscriptContent.vue?vue&type=script&lang=js&"
import style0 from "./manuscriptContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports